/** @format */

import React from 'react';
import withFeedbackHandler from './with_feedback_handler';
import {ConditionalButton} from 'frontier-utilities';
import {handleChange} from 'frontier-form';
import {InputWithErrorHandler, TextAreaWithErrorHandler} from 'frontier-form';

export default withFeedbackHandler(
    handleChange(props => {
        return (
            <div>
                <div className="fields">
                    {props.isSubmissionSuccessful && (
                        <div className="success-overlay">
                            <h3 style={{textAlign: 'center'}}>Thank you for your submission!</h3>
                            <p style={{textAlign: 'center'}}>
                                We appreciate you taking the time to provide us with your feedback
                                and the opportunity to improve. Someone from leadership will be in
                                touch if a follow up is necessary.
                            </p>
                        </div>
                    )}
                    <h3 style={{textAlign: 'left'}}>Contact our CEO Directly</h3>
                    <p style={{textAlign: 'left'}}>
                        We appreciate you taking the time to reach out to our CEO directly with your
                        feedback. For immediate assistance or questions about active orders or
                        quotes, please{' '}
                        <a style={{color: '##00892F'}} href="/contact">
                            contact
                        </a>{' '}
                        our team via phone, chat or{' '}
                        <span
                            style={{color: '#00892F', cursor: 'pointer'}}
                            onClick={() => {
                                window.HubSpotConversations.widget.open();
                            }}>
                            message.
                        </span>
                    </p>
                    <p style={{fontSize: '12px', position: 'relative', top: '10px', left: '6px'}}>
                        *985 max characters
                    </p>
                    <TextAreaWithErrorHandler
                        error={props.error}
                        errorPath="comment"
                        className="form-control form-control-sm feedback-ta"
                        value={props.formData.comment}
                        onChange={props.onInputChange.bind(this, 'formData.comment')}
                        placeholder="Tell us some more information..."
                        maxLength={985}
                    />
                    <InputWithErrorHandler
                        error={props.error}
                        errorPath="email"
                        className="form-control-sm form-control feedback-input"
                        value={props.formData.email}
                        onChange={props.onInputChange.bind(this, 'formData.email')}
                        placeholder="Enter email address..."
                    />
                    <ConditionalButton enabled={!props.sending}>
                        <button
                            style={{borderRadius: '4px', float: 'left'}}
                            onClick={props.onSend}
                            className="btn btn-primary submit-btn">
                            Submit
                        </button>
                        <button
                            style={{borderRadius: '4px', float: 'left'}}
                            disabled="disabled"
                            className="btn btn-primary submit-btn">
                            Submitting...
                        </button>
                    </ConditionalButton>
                    {/*<span*/}
                    {/*    className="report-bug-text"*/}
                    {/*    onClick={() => {*/}
                    {/*        props.toggleFeedback(false);*/}
                    {/*        props.toggleModal(false);*/}
                    {/*        props.bhClick();*/}
                    {/*    }}>*/}
                    {/*    Report a Bug*/}
                    {/*</span>*/}
                </div>
            </div>
        );
    })
);
